import { daysTo } from './dates.js';
/**
 * Classify a car's APK status against the reminder window. Ported 1:1 from the
 * prototype `apkInfo`.
 */
export function apkInfo(apkVervaldatum, apkReminderDays, now = new Date()) {
    const d = daysTo(apkVervaldatum, now);
    if (d == null)
        return { badge: 'Onbekend', tone: 'neutral', urgent: false, dagen: d };
    if (d < 0)
        return { badge: 'Verlopen', tone: 'danger', urgent: true, dagen: d };
    if (d <= apkReminderDays)
        return { badge: `${d} dagen`, tone: 'warning', urgent: true, dagen: d };
    return { badge: 'OK', tone: 'success', urgent: false, dagen: d };
}
//# sourceMappingURL=apk.js.map